import type { FetchParams, PaginatedResponse } from "@nuxt/app";
import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  SubscriptionFreeDayClaimEvent,
  SubscriptionFreeDayStatisticsResponse,
  SubscriptionRetentionResponse,
  SubscriptionStatisticsResponse,
} from "~/types/admin/payment";

class AdminPaymentStatisticsModule extends HttpFactory {
  async getSubscriptionStatistics(): Promise<SubscriptionStatisticsResponse> {
    return await this.get(
      `${ENDPOINTS.ADMIN.PROFILES.SUBSCRIPTION_STATISTICS}`,
    );
  }

  async getSubscriptionRetentionStatistics(): Promise<SubscriptionRetentionResponse> {
    return await this.get<SubscriptionRetentionResponse>(
      `${ENDPOINTS.ADMIN.PAYMENT.SUBSCRIPTION_RETENTION_STATISTICS}`,
    );
  }

  async getSubscriptionFreeDayStatistics(): Promise<SubscriptionFreeDayStatisticsResponse> {
    return await this.get<SubscriptionFreeDayStatisticsResponse>(
      `${ENDPOINTS.ADMIN.PAYMENT.SUBSCRIPTION_FREE_DAY_STATISTICS}`,
    );
  }

  async getSubscriptionFreeDayEvents(
    fetchParams: FetchParams,
  ): Promise<PaginatedResponse<SubscriptionFreeDayClaimEvent>> {
    return await this.get<PaginatedResponse<SubscriptionFreeDayClaimEvent>>(
      `${ENDPOINTS.ADMIN.PAYMENT.SUBSCRIPTION_FREE_DAY_EVENTS}`,
      fetchParams,
    );
  }
}

export { AdminPaymentStatisticsModule };
